import moment from 'moment';
import memoize from 'lodash/memoize';

/*
  Daylight saving (DST) for all future summers in New South Wales
    - begins at 02:00 on the first Sunday in October, clocks are moved forward one hour (UTC +11)
      (in UTC+0 it's first Saturday of October, 16:00)
    - ends at 03:00 on the first Sunday in April, clocks go back one hour (UTC +10)
      (in UTC+0 it's first Saturday of April, 16:00)

    As start/end time in UTC+0 is always the same, then:
      - `dateTime` passed to the function is converted to UTC+0
      - based on the year of that date, DST start/end are calculated
      - proper offset is calulated and added to `dateTime` in UTC+0
*/

const daylightStartForYear = memoize((year) => (
  moment.utc(year, 'YYYY')
    .month('October') // sets month to October
    .date(1) // sets first day of month (1-31)
    .day('Saturday') // changes day to next Saturday
    .hour(15) // sets hours to 16 (zero indexed)
));

const daylightEndForYear = memoize((year) => (
  moment.utc(year, 'YYYY')
    .month('April')
    .date(1)
    .day('Saturday')
    .hour(15)
));

export default (dateTime = moment(), format = 'YYYY-MM-DD') => {
  const utcDate = moment.utc(dateTime);
  const year = utcDate.year();
  let offset = 11;
  if (utcDate.isBetween(daylightEndForYear(year), daylightStartForYear(year), null, '[)')) {
    offset = 10;
  }
  return utcDate.add(offset, 'hours').format(format);
};
